import { useRouter } from 'next/router';
import { useJnzAuth } from '../index';
import CustomLoadingOverlay from '../components/CustomLoadingOverlay'
import hoistNonReactStatics from 'hoist-non-react-statics'

const withJnzAuth = ({
  redirectIfAuthenticated = false,
  redirectIfNotAuthenticated = false,
  redirectIfNoCompany = false,
} = {}) => (ChildComponent) => {

  const WithAuthUserHOC = (props) => {
    const { ...otherProps } = props
    const router = useRouter();
    const { isLogin, isLoading, redirect } = useJnzAuth()

    let returnVal = <div>  bad </div>
    const loaderComp = isLoading ? <CustomLoadingOverlay isLoading={true} /> : null;
    const comps = (<ChildComponent {...otherProps} />)

    if (isLoading) {
      returnVal = loaderComp
    } else if (!isLogin) {
      if (redirectIfNotAuthenticated) {
        router.push(redirect.redirectIfNotAuthenticated);
        returnVal = "Redirect..."
      } else {
        returnVal = comps
      }
    } else if (isLogin) {
      if (redirectIfAuthenticated) {
        router.push(redirect.redirectIfAuthenticated);
        returnVal = "Redirect..."
      } else if (redirectIfNoCompany) {
        router.push(redirect.redirectIfNoCompany);
        returnVal = "Redirect..."
      } else {
        returnVal = comps
      }
    } else {
      returnVal = comps
    }

    return returnVal
  }

  WithAuthUserHOC.displayName = 'WithAuthUserHOC'
  hoistNonReactStatics(WithAuthUserHOC, ChildComponent)
  return WithAuthUserHOC
}

export default withJnzAuth;
